<template>
  <AVProgressBar
    :id="id"
    :value="progressPercentage"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType, ConferenceVotingRoundOrchestrator } from "@/types";

export default defineComponent({
  name: "ResultOrchestratorProgress",
  props: {
    id: {
      type: String,
      required: true,
    },
    resultOrchestrator: {
      required: true,
      type: Object as PropType<ConferenceVotingRoundOrchestrator>,
    },
    trusteeCount: {
      type: Number,
      default: 1
    }
  },
  computed: {
    packageCounts(){
      return {
        mp_current: this.resultOrchestrator.mixingPackages.filter((p) => p.packageValidation).length,
        mp_total: this.resultOrchestrator.mixingPackages.filter((p) => p.status !== "cancelled").length,
        dp_current: this.resultOrchestrator.decryptionPackages.filter((p) => p.packageValidation).length,
        dp_total:
          this.resultOrchestrator.decryptionPackages.length == 0
            ? this.trusteeCount
            : this.resultOrchestrator.decryptionPackages.filter((p) => p.status !== "cancelled").length,
      }
    },
    aggregation() {
      return this.resultOrchestrator.status == "finished" ? 1 : 0
    },
    progress() {
      return this.packageCounts.dp_current + this.packageCounts.mp_current + this.aggregation
    },
    progressMax() {
      return Math.max(this.packageCounts.dp_total + this.packageCounts.mp_total, 1) + 1 // +1 for aggregation
    },
    progressPercentage() {
      return Math.max(100 * (this.progress / this.progressMax), 0);
    },
  }

});
</script>
